import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "airplay"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M17.4 18l-1-1.3h5.4V6.3H3.1v10.4h5.4l-1 1.3H2V5h21v13h-5.6zm-4.9-4.8l5.4 6.8H7.1l5.4-6.8z"
})));